export const spacer = Object.freeze({
    xxsmall: "10px",
    xsmall: "40px",
    small: "70px",
    medium: "100px",
    large: "150px"
})

export const breakpoints = [480, 768, 992, 1200]
